import { render, staticRenderFns } from "./MitraPaxel.vue?vue&type=template&id=a8835090&"
import script from "./MitraPaxel.vue?vue&type=script&lang=js&"
export * from "./MitraPaxel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports